var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStraightBurgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "none",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4h19a1.5 1.5 0 010 3h-19a1.5 1.5 0 010-3zm0 15h19a1.5 1.5 0 010 3h-19a1.5 1.5 0 010-3zm0-7.5h19a1.5 1.5 0 010 3h-19a1.5 1.5 0 010-3z",
    fillOpacity: 0.6
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIHN0cm9rZT0ibm9uZSIgZmlsbD0ibm9uZSIgZmlsbC1vcGFjaXR5PSIwIiBzdHJva2Utb3BhY2l0eT0iMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIvPgogICAgICAgIDxwYXRoIGQ9Ik0zLjUgNGgxOWExLjUgMS41IDAgMCAxIDAgM2gtMTlhMS41IDEuNSAwIDAgMSAwLTN6bTAgMTVoMTlhMS41IDEuNSAwIDAgMSAwIDNoLTE5YTEuNSAxLjUgMCAwIDEgMC0zem0wLTcuNWgxOWExLjUgMS41IDAgMCAxIDAgM2gtMTlhMS41IDEuNSAwIDAgMSAwLTN6IiBmaWxsLW9wYWNpdHk9Ii42Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgStraightBurgerMenu as ReactComponent };